import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../../../core/config/common.settings';
import { LoadingService } from '../../../core/services/loading.service';

@Injectable()
export class VerifyEmailService {
  constructor(
    private http: HttpClient,
    private loadingService: LoadingService
  ) {}

  verifyEmail(token: string): Promise<any> {
    this.loadingService.start();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/admin/verify-email`, { token })
        .subscribe({
          next: (response: any) => {
            this.loadingService.stop();
            resolve(response);
          },
          error: (error: any) => {
            this.loadingService.stop();
            reject(error);
          },
        });
    });
  }

  resendVerificationEmail(email: string): Promise<any> {
    this.loadingService.start();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/admin/resend-verification`, { email })
        .subscribe({
          next: (response: any) => {
            this.loadingService.stop();
            resolve(response);
          },
          error: (error: any) => {
            this.loadingService.stop();
            reject(error);
          },
        });
    });
  }
}
